window.addEventListener('DOMContentLoaded', function (e) {
  jQuery(function ($) {
    $('.guide-card[data-uuid]').on('click', function (e) {
      console.debug('Open modal');
      e.preventDefault();
      e.stopImmediatePropagation();

      let formModalWrapper = $('.form-modal-wrapper');

      if (!formModalWrapper.length) return;

      let cardUuid = $(this).attr('data-uuid');
      let formId = $(this).attr('data-form-id');

      if (!cardUuid || !formId) {
        console.error('Missing card or form id');
        return;
      }

      formModalWrapper.toggleClass('open');
      formModalWrapper.attr('data-card-uuid', $(this).attr('data-uuid'));
      formModalWrapper.attr('data-form-id', $(this).attr('data-form-id'));

      formModalWrapper
        .find('.pxFormGenerator')
        .prop('id', $(this).attr('data-form-id'));

      formModalWrapper
        .find('.pxFormGenerator')
        .attr('data-card-id', $(this).attr('data-uuid'));

      $('html').toggleClass(
        'overflow-hidden',
        formModalWrapper.hasClass('open'),
      );

      formModalWrapper.find(`.pxFormGenerator`).toggleClass('hidden', true);

      formModalWrapper
        .find(`.pxFormGenerator[id='${formId}']`)
        .toggleClass('hidden');
    });

    $('.form-modal-wrapper .close-overlay').on('click', function (e) {
      e.preventDefault();

      let formModalWrapper = $('.form-modal-wrapper');

      formModalWrapper.toggleClass('open');
      $('html').toggleClass(
        'overflow-hidden',
        formModalWrapper.hasClass('open'),
      );
    });
  });
});
